import { styled } from "styled-components";
import { colors } from "constants/colors";
import { StyledText } from "styles/Text";

interface Props {
  id: number;
  labelText: string;
  selected: boolean;
  onValueChange: (id: number) => void; // onPress 함수
  disabled?: boolean;
  padding?: string;
}

const RadioAndLabel = ({
  id,
  labelText,
  selected,
  onValueChange,
  disabled,
  padding,
}: Props) => {
  return (
    <StyledContainerView $padding={padding}>
      <input
        type="radio"
        id={String(id)}
        onChange={() => onValueChange(id)}
        checked={selected}
        disabled={!!disabled}
      />
      <span className="custom_input" />
      <StyledText.Body15 as="label" htmlFor={String(id)}>
        {labelText}
      </StyledText.Body15>
    </StyledContainerView>
  );
};
export default RadioAndLabel;

const StyledContainerView = styled.div<{ $padding?: string }>`
  position: relative;
  display: flex;
  align-items: flex-start;
  padding: ${({ $padding }) => ($padding ? $padding : "8px 20px 8px 16px")};
  .custom_input {
    display: inline-block;
    width: 26px;
    height: 26px;
    margin: 5px;
    border-radius: 13px;
    border: 1px solid ${colors.lightGray1};
    box-sizing: border-box;
    vertical-align: top;
    &:before {
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      margin: auto;
      background-color: ${colors.mainOrange};
      border-radius: 5px;
    }
    + label {
      flex: 1;
      align-self: center;
      padding-left: 4px;
    }
  }
  input {
    appearance: none;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    opacity: 0;
    &:checked {
      + .custom_input {
        position: relative;
        border-color: ${colors.mainOrange};
        &:before {
          content: "";
          width: 10px;
          height: 10px;
        }
      }
    }
  }
`;
